// responsive fb widget

var a = null;

window.addEventListener('resize', function() {
  if (a !== null) {
    clearTimeout(a);
  }
  a = setTimeout(function() {
    FB.XFBML.parse();
  }, 1000);
});

// instafeed

var Instafeed = require('instafeed.js');
var instafeedContainer = document.querySelector('#instafeed');

if (instafeedContainer) {
  var feed = new Instafeed({
    get: 'user',
    userId: '5352745557',
    clientId: 'bc762b724e13462ca47d0d787d7b9fec',
    accessToken: '5352745557.bc762b7.30eefabe1ac1449db894c3681a30ebb1',
    target: 'instafeed',
    limit: 12
  });
  
  feed.run();
}
